// A failed quiz becomes eligible for requiz once this many days have passed since that attempt.
export const REQUIZ_COOLDOWN_DAYS = 14;

// A passed quiz becomes eligible as a refresher once this many days have passed since that attempt.
export const REFRESHER_COOLDOWN_DAYS = 30;

// Cap on how many quizzes we look up attempt history for in a single request, to keep the
// aliased PopQuizAttemptLookup query (one round trip, N aliased fields) bounded.
export const MAX_ATTEMPT_LOOKUPS = 10;
